<template>
<div class="custom-main">
  <home-page />
  <chat-box />
</div>
</template>

<script>
  import HomePage from '../../components/HomePage'
  import ChatBox from '../../components/ChatBox'

  export default {
    name: 'Home',

    components: {
      HomePage,
      ChatBox,
    },
  }
</script> 
